export default {
  'hero.tagline': 'Global Data Infrastructure',
  'hero.mainTitle': 'Data Returns to the Axis',
  'hero.subTitle': 'Data Returns to the Axis',
  'hero.description': 'From chip-level storage to top-tier architecture, AX Axis reshapes the data ecosystem — ensuring every piece of data flows securely, efficiently, and intelligently around the Axis.',
  'hero.cta': 'Explore the Ecosystem',
  'hero.brandIdentifier': 'AX AXIS INTERNATIONAL HOLDING LIMITED',

  'identity.label': 'Who We Are',
  'identity.companyName': 'AX Axis International Holding Limited',
  'identity.vision': 'To become a global leader in private-domain data ecosystems, ensuring every piece of data flows securely, efficiently, and intelligently around the Axis.',
  'identity.description': 'We are a leading provider of high-performance storage solutions and network infrastructure, dedicated to delivering full-chain data support from chip-level foundations to top-tier architecture for enterprises and individual users alike.',
  'identity.feature1.title': 'Secure',
  'identity.feature1.desc': 'End-to-end data security assurance',
  'identity.feature2.title': 'Efficient',
  'identity.feature2.desc': 'Enterprise-grade data transmission',
  'identity.feature3.title': 'Intelligent',
  'identity.feature3.desc': 'Localized AI processing',
  'identity.cta': 'Discover Our Story',

  'business.title': 'What We Do',
  'business.subtitle': 'Three Engines',
  'business.chipTrade.name': 'Global Chip Trade',
  'business.chipTrade.nameEn': 'Global Chip Trade',
  'business.chipTrade.desc': 'We specialize in global import/export of NAND Flash and DRAM memory chips. With deep industry expertise, AX Axis has established solid quota partnerships with leading global manufacturers and distributors, ensuring stable spot supply and highly competitive pricing even during market volatility.',
  'business.chipTrade.spec': 'NAND / DRAM',
  'business.consumerBrand.name': 'Premium Storage Brand',
  'business.consumerBrand.nameEn': 'Consumer Storage Brand',
  'business.consumerBrand.desc': 'AX Axis merges hardcore technology with minimalist industrial aesthetics. Our product line spans high-performance portable drives, high-speed SD/TF memory cards, and enterprise-grade SSDs — each product representing our relentless pursuit of performance and uncompromising dedication to design.',
  'business.consumerBrand.spec': 'SSD / SD / HDD',
  'business.aiNAS.name': 'AI NAS Intelligent System',
  'business.aiNAS.nameEn': 'Axis OS',
  'business.aiNAS.desc': 'Axis OS is our independently developed core software ecosystem. Designed for the AI era, this intelligent storage system delivers military-grade encrypted local private cloud solutions for enterprises and homes alike. With zero-config intranet penetration and an exceptional user experience, data assets achieve seamless cross-region collaboration under absolute security.',
  'business.aiNAS.spec': 'Axis OS / AI Ready',

  'strategy.label': 'Where We Are',
  'strategy.title': 'Where We Are',
  'strategy.subtitle': 'Hong Kong R&D, Global Ecosystem — building a robust commercial architecture with Hong Kong as the core engine',
  'strategy.hk.title': 'Rooted in Hong Kong',
  'strategy.hk.subtitle': 'Rooted in Hong Kong',
  'strategy.hk.desc': 'With a dedicated R&D team based in Hong Kong, focused on developing AX Axis products.',
  'strategy.hk.points.0': 'Axis OS independently developed',
  'strategy.hk.points.1': 'Intellectual property protection',
  'strategy.hk.points.2': 'International brand credibility',
  'strategy.hk.tag': 'Hong Kong R&D Center',
  'strategy.cn.title': 'Powered by Mainland China',
  'strategy.cn.subtitle': 'Powered by Mainland China',
  'strategy.cn.desc': 'Deep integration with the Greater Bay Area and mainland China\'s leading electronics manufacturing supply chain, ensuring efficient delivery and cost control.',
  'strategy.cn.points.0': 'Semiconductor packaging & testing',
  'strategy.cn.points.1': 'Efficient supply chain integration',
  'strategy.cn.points.2': 'Greater Bay Area manufacturing edge',
  'strategy.cn.tag': 'Manufacturing Supply Chain',
  'strategy.global.title': 'Global Market Focus',
  'strategy.global.subtitle': 'Global Market Focus',
  'strategy.global.desc': 'Leveraging Hong Kong as a hub, exporting storage solutions to global markets through international logistics and multilingual support.',
  'strategy.global.points.0': 'International logistics system',
  'strategy.global.points.1': 'Multilingual technical support',
  'strategy.global.points.2': 'Global market penetration',
  'strategy.global.tag': 'Global Market Expansion',

  'advantage.title': 'Why Choose Us',
  'advantage.subtitle': 'Independent OS · Full-Chain R&D · Hong Kong Brand · Industrial Aesthetics',
  'advantage.item1.title': 'Proprietary System Moat',
  'advantage.item1.desc': 'Axis OS, built by our Hong Kong R&D team, ensures absolute autonomy at the system level and globally-leading security.',
  'advantage.item2.title': 'Full-Chain R&D Capability',
  'advantage.item2.desc': 'Deep vertical integration from raw chips through system firmware to end-user interfaces.',
  'advantage.item3.title': 'International Brand Edge',
  'advantage.item3.desc': 'A Hong Kong-based brand enjoys stronger trust among global premium and enterprise/government users.',
  'advantage.item4.title': 'Ultimate Industrial Aesthetics',
  'advantage.item4.desc': 'Tesla-inspired visual language attracts high-end audiences who value quality of life.',

  'roadmap.label': 'Our Roadmap',
  'roadmap.title': 'Our Roadmap',
  'roadmap.description': '2021 — 2026 Key Milestones: from Hong Kong to the world, reshaping global data standards',
  'roadmap.milestone1.quarter': '2021',
  'roadmap.milestone1.title': 'Company Founded in Hong Kong',
  'roadmap.milestone1.desc': 'Officially established in Hong Kong, positioning as a global storage chip trading company.',
  'roadmap.milestone2.quarter': '2022 - 2023',
  'roadmap.milestone2.title': 'Global Trade Launch',
  'roadmap.milestone2.desc': 'Leveraging mainland supply chain advantages to launch global trade initiatives and penetrate terminal storage markets worldwide.',
  'roadmap.milestone3.quarter': 'Q4 2025',
  'roadmap.milestone3.title': 'Terminal Storage Penetration',
  'roadmap.milestone3.desc': 'Accelerating channel deployment of USB drives, portable hard drives, and other terminal products across global markets.',
  'roadmap.milestone4.quarter': '2026+',
  'roadmap.milestone4.title': 'Accelerating Axis OS R&D',
  'roadmap.milestone4.desc': 'Team accelerating OS development and NAS product iteration',
  'roadmap.bottomLine1': 'Axis — Data Returns to the Core',
  'roadmap.bottomLine2': 'DATA RETURNS TO THE AXIS',

  'careers.label': 'Join Us',
  'careers.title': 'Join Us',
  'careers.description': 'We are looking for passionate talent to build world-leading data infrastructure together. Join us and drive innovation and industry transformation.',
  'careers.position1.title': 'Software Engineer',
  'careers.position1.desc': 'Contribute to Axis OS core system development and build the next-generation intelligent storage platform.',
  'careers.position2.title': 'Hardware Engineer',
  'careers.position2.desc': 'Lead hardware design, testing, and optimization for storage devices and terminal products.',
  'careers.position3.title': 'International Business Development',
  'careers.position3.desc': 'Expand global market channels and establish international partnerships.',
  'careers.ctaTitle': 'Interested in joining our team?',
  'careers.ctaDesc': 'Send your resume to the email below. We look forward to hearing from you.',
};